import React, { useState, useEffect } from 'react';
import { HeaderProps } from '../../types';
import ThemeSwitch from '../ThemeSwitch/ThemeSwitch';
import './Header.css';

const Header: React.FC<HeaderProps> = ({
  measurementUnits,
  setMeasurementUnits,
  websiteType,
  toggleTheme,
  theme,
}) => {
  const handleChange = (event: any) => {
    const selectedValue = event.target.value;
    setMeasurementUnits(selectedValue);
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const showUnitsSelection = websiteType === 'sailors';

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize, { passive: true });

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const logoEolosSrc =
    theme === 'light'
      ? 'assets/img/logo-eolos.svg'
      : 'assets/img/logo-eolos_dark.svg';

  const logoAppSrc =
    theme === 'light'
      ? 'assets/img/logo-sailorsApp.svg'
      : 'assets/img/logo-sailorsApp_dark.svg';

  return (
    <div className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand navbar-logo">
          <img src={logoEolosSrc} alt="Eolos" className="navbar-eolos" />
        </div>
        <div className="navbar-brand navbar-center">
          <img src={logoAppSrc} alt="Sailors App" />
        </div>
        <div className="navbar-right">
          <div className="navbar-brand">
            <ThemeSwitch toggleTheme={toggleTheme} theme={theme} />
          </div>
          <div className="navbar-brand">
            {showUnitsSelection &&
              (windowSize.width < 992 ? (
                <select value={measurementUnits} onChange={handleChange}>
                  <option value="INT">INT</option>
                  <option value="IMP">IMP</option>
                </select>
              ) : (
                <>
                  <label>Units:</label>
                  <select value={measurementUnits} onChange={handleChange}>
                    <option value="INT">International</option>
                    <option value="IMP">Imperial</option>
                  </select>
                </>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
